(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('painelAddTask', PainelAddTask);

  function PainelAddTask() {
    return {
      restrict: 'E',
      templateUrl: 'views/propriedade/tarefa-edicao.html',
      controller: 'TarefaCtrl',
      controllerAs: 'tarefa',
      scope: {
        data: '<'
      }
    };
  }
}());
